import React, { useState } from "react";
import { useKeycloak } from "react-keycloak";
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  KebabToggle,
  Button,
  ButtonVariant,
  PageHeaderTools,
  PageHeaderToolsGroup,
  PageHeaderToolsItem
} from "@patternfly/react-core";
import { BellIcon, CogIcon } from "@patternfly/react-icons";
import Avatar from "./Avatar";
import imgAvatar from "./imgAvatar.svg";

export default () => {
  const [keycloak] = useKeycloak();
  const name = keycloak.tokenParsed && keycloak.tokenParsed.name;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isKebabDropdownOpen, setIsKebabDropdownOpen] = useState(false);

  function onDropdownToggle() {
    setIsDropdownOpen(!isDropdownOpen);
  }

  function onDropdownSelect() {
    setIsDropdownOpen(!isDropdownOpen);
  }

  function onKebabDropdownSelect() {
    setIsKebabDropdownOpen(!isKebabDropdownOpen);
  }

  function onKebabDropdownToggle() {
    setIsKebabDropdownOpen(!isKebabDropdownOpen);
  }

  const userDropdownItems = !!keycloak.authenticated
    ? [
        <DropdownItem key="log out" onClick={() => keycloak.logout()}>
          Log out
        </DropdownItem>,
      ]
    : [];

  const kebabDropdownItems = [
    <DropdownItem key='kebab-notification'>
      <BellIcon /> Notifications
    </DropdownItem>,
    <DropdownItem key='kebab-setting'>
      <CogIcon /> Settings
    </DropdownItem>
  ];

  return (
    <PageHeaderTools>
      <PageHeaderToolsGroup
        visibility={{
          default: 'hidden',
          lg: 'visible'
        }} /** the settings and help icon buttons are only visible on desktop sizes and replaced by a kebab dropdown for other sizes */
      >
        <PageHeaderToolsItem>
          <Button
            id="defaßlt-example-uid-01"
            aria-label="Notifications actions"
            variant={ButtonVariant.plain}
          >
            <BellIcon />
          </Button>
        </PageHeaderToolsItem>
        <PageHeaderToolsItem>
          <Button
            id="default-example-uid-02"
            aria-label="Settings actions"
            variant={ButtonVariant.plain}
          >
            <CogIcon />
          </Button>
        </PageHeaderToolsItem>
      </PageHeaderToolsGroup>
      <PageHeaderToolsGroup>
        <PageHeaderToolsItem
          visibility={{
            lg: 'hidden'
          }} /** this kebab dropdown replaces the icon buttons and is hidden for desktop sizes */
        >
          <Dropdown
            isPlain
            position="right"
            onSelect={() => onKebabDropdownSelect()}
            toggle={<KebabToggle onToggle={() => onKebabDropdownToggle()} />}
            isOpen={isKebabDropdownOpen}
            dropdownItems={kebabDropdownItems}
          />
        </PageHeaderToolsItem>
      </PageHeaderToolsGroup>
      <PageHeaderToolsGroup>
        <PageHeaderToolsItem
          visibility={{ default: 'hidden', md: 'visible' }} /** this user dropdown is hidden on mobile sizes */
        >
          <Dropdown
            isPlain
            position="right"
            onSelect={() => onDropdownSelect()}
            isOpen={isDropdownOpen}
            toggle={
              <DropdownToggle onToggle={() => onDropdownToggle()}>
                {name}
              </DropdownToggle>
            }
            dropdownItems={userDropdownItems}
          />
        </PageHeaderToolsItem>
      </PageHeaderToolsGroup>
      <Avatar imgAvatar={imgAvatar} />
    </PageHeaderTools>
  );
};
